import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=6c9ec33a&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=6c9ec33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9ec33a",
  null
  
)

export default component.exports
import {QCard,QCardSection,QMarkupTable,QDialog,QOptionGroup,QCardActions,QBtn,QTable,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QMarkupTable,QDialog,QOptionGroup,QCardActions,QBtn,QTable})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
